import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CommonsUtils } from 'app/commons/CommonsUtils';

export interface OtroSeguro {
    /** Clave estable del catálogo (CommonsUtils.otherProducs), para filtrar sin mirar el título. */
    id?: string;
    title: string;
    description: string;
    link?: string;
    icon: string;
    nuevo?: boolean;
}

@Component({
    selector: 'app-other-insurance',
    templateUrl: './other-insurance.component.html',
    styleUrls: ['./other-insurance.component.scss']
})
export class OtherInsuranceComponent {

    @Input() seguros: OtroSeguro[] = CommonsUtils.otherProducs();
    @Input() subtitulo: string = '';
    @Input() footer: string = 'Soluciones adaptadas a tus necesidades.';

    constructor(private router: Router) {}

    get items(): OtroSeguro[] {
        return (this.seguros || []).slice(0, 3);
    }

    irA(link: string): void {
        this.router.navigate([link]);
    }

    abrirEnlace(link: string): void {
        if (link) {
            window.open(link, '_blank', 'noopener');
        }
    }

    iconForInsurance(s: OtroSeguro, idx: number): string {
        const base = 'resources/assets/images/main-page/';
        const map: { [k: string]: string } = {
            plane:        'onlygal-asistencia-viaje.svg',
            travel:       'onlygal-asistencia-viaje.svg',
            viaje:        'onlygal-asistencia-viaje.svg',
            asistencia:   'onlygal-asistencia-viaje.svg',
            home:         'onlygal-compraventa-asegurada.svg',
            compraventa:  'onlygal-compraventa-asegurada.svg',
            vivienda:     'onlygal-compraventa-asegurada.svg',
            alquiler:     'onlygal-compraventa-asegurada.svg',
            shieldcheck:  'onlygal-abogado-365.svg',
            legal:        'onlygal-abogado-365.svg',
            abogado:      'onlygal-abogado-365.svg',
            ocupacion:    'onlygal-abogado-365.svg',
            car:          'car.svg',
            coche:        'car.svg'
        };
        const defaults = ['onlygal-asistencia-viaje.svg', 'onlygal-compraventa-asegurada.svg', 'onlygal-abogado-365.svg'];
        const key = ((s && s.icon) || '').toLowerCase().trim();

        for (const k of Object.keys(map)) {
            if (key && key.indexOf(k) !== -1) { return base + map[k]; }
        }
        return base + (defaults[idx % defaults.length] || 'bag-2.svg');
    }
}
